// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"1b789ca4","97":"b506c9da","145":"825962f1","165":"564d0fba","255":"b0dc83b4","318":"563d8473","393":"602d392d","488":"a80978e5","492":"f8689934","502":"e9b038c0","580":"eefb4472","738":"bada36f9","796":"a5c85b87","916":"895eadca"}[chunkId] + ".chunk.js";
};